const getHeaderMinHeight = (spacingUnit: number) => spacingUnit * 45;

export { getHeaderMinHeight };
